import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { TransloadOrders_ModuleContextService } from './TransloadOrders.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class TransloadOrders_order_expected_licenseplate_count_widget_ComponentContextService {
  private readonly moduleContext: TransloadOrders_ModuleContextService;

  constructor(moduleContext: TransloadOrders_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'order_expected_licenseplate_count_widget',
      type: ComponentType.widget
    }
  }
}